import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/index/print.png';
const _withScopeId = n => (_pushScopeId("data-v-7a47ff80"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "print-container"
};
const _hoisted_2 = {
  class: "print-box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "print-left",
  src: _imports_0
}, null, -1));
const _hoisted_4 = {
  class: "print-right"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "print-title"
}, [/*#__PURE__*/_createTextVNode(" Start Your "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("3D Printing Journey Today! ")], -1));
const _hoisted_6 = {
  class: "print-subtitle"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "TicPrint", -1));
const _hoisted_8 = {
  class: "print-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createTextVNode(" Sign up now and generate your first 3D model from a photo for free! Turn your pet into a one-of-a-kind masterpiece, exclusively at "), _hoisted_7, _createTextVNode("! Visit ["), _createVNode(_component_router_link, {
    to: "/edit-project"
  }, {
    default: _withCtx(() => [_createTextVNode("New Project")]),
    _: 1
  }), _createTextVNode("] now to create your personalized artwork! ")]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: "fir",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('goPage'))
  }, " Start for free "), _createElementVNode("div", {
    class: "sec",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.page && _ctx.page(...args))
  }, "Learn more")])])])]);
}